import axios from "axios";

// Singleton service for Splinterlands settings with request deduplication
class SplinterlandsSettingsService {
  constructor() {
    this.settings = null;
    this.lastFetch = 0;
    this.CACHE_DURATION = 10 * 1000; // Only 10 seconds cache to keep data fresh for market
    this.subscribers = [];
    this.pendingRequest = null; // Track ongoing request for deduplication
  }

  async getSettings() {
    // If we have recent settings (< 10 seconds old), return them
    if (this.settings && Date.now() - this.lastFetch < this.CACHE_DURATION) {
      return this.settings;
    }

    // If a request is already in progress, wait for it instead of making a new one
    if (this.pendingRequest) {
      return this.pendingRequest;
    }

    // Start new request and store the promise
    this.pendingRequest = this._fetchSettings();
    
    try {
      const settings = await this.pendingRequest;
      return settings;
    } finally {
      // Clear pending request after it completes
      this.pendingRequest = null;
    }
  }

  async _fetchSettings() {
    try {
      const response = await axios.get('https://api2.splinterlands.com/settings');
      if (response.data) {
        this.settings = response.data;
        this.lastFetch = Date.now();
        this.notifySubscribers();
        return this.settings;
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
      // Return old settings if available, otherwise null
      return this.settings;
    }
  }

  getEditionName(editionId) {
    if (!this.settings || !this.settings.editions) return "Unknown";
    const edition = this.settings.editions[String(editionId)];
    return edition ? edition.name : "Unknown";
  }

  subscribe(callback) {
    this.subscribers.push(callback);
    if (this.settings) callback(this.settings);
    return () => {
      this.subscribers = this.subscribers.filter(sub => sub !== callback);
    };
  }

  notifySubscribers() {
    this.subscribers.forEach(cb => cb(this.settings));
  }
}

const splinterlandsSettingsService = new SplinterlandsSettingsService();
export default splinterlandsSettingsService;
